module.exports = __webpack_public_path__ + "media/images/whyflt-1e8e8887a0d91ad420485389a42e9b68.png";